export function convertVhToPixels(value: number) {
  return (value / 100) * window.innerHeight;
}
